import { Controller } from "@hotwired/stimulus"

// Countdown timer for rate-limited error page.
// Counts down from retryAfterValue, then swaps the countdown
// for a "Try again" button via CSS class toggles.
export default class extends Controller {
  static targets = ["display", "countdown", "retry"]
  static values = { retryAfter: Number }

  connect() {
    this.remaining = this.retryAfterValue
    this.update()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    this.remaining--
    this.update()

    if (this.remaining <= 0) {
      clearInterval(this.timer)
      this.countdownTarget.classList.add("hidden")
      this.retryTarget.classList.remove("hidden")
    }
  }

  update() {
    this.displayTarget.textContent = this.remaining
  }

  goBack() {
    window.history.back()
  }

  tryAgain() {
    window.location.href = document.referrer || "/"
  }
}
